"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateDownloadLink = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var theme_1 = require("../../theme");
var card_1 = require("../card");
var flexbox_1 = require("../flexbox");
var icons_1 = require("../icons");
var padding_1 = require("../padding");
var text_1 = require("../text");
var StyledAnchor = styled_components_1.default.a(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  display: block;\n  text-decoration: none !important;\n"], ["\n  display: block;\n  text-decoration: none !important;\n"])));
var ICONS_MAP = {
    spreadsheet: icons_1.IconSpreadsheet,
};
function TemplateDownloadLink(_a) {
    var header = _a.header, _b = _a.icon, icon = _b === void 0 ? 'spreadsheet' : _b, url = _a.url, urlText = _a.urlText;
    var Icon = ICONS_MAP[icon];
    return (react_1.default.createElement(StyledAnchor, { href: url, target: "_blank", rel: "noopener noreferrer" },
        react_1.default.createElement(card_1.Card, null,
            react_1.default.createElement(padding_1.Padding, { size: 16 },
                react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "center" },
                    react_1.default.createElement(Icon, null),
                    react_1.default.createElement(flexbox_1.Flexbox, { flexDirection: "column", marginLeft: 16 },
                        react_1.default.createElement(text_1.Text, null, header),
                        react_1.default.createElement(text_1.Text, { color: theme_1.colors.primary, size: "small" }, urlText)))))));
}
exports.TemplateDownloadLink = TemplateDownloadLink;
var templateObject_1;
//# sourceMappingURL=index.js.map